import { axiosInstance as request } from '@/api/rest.service'

export const storeArticle = payload => request.post('/research-output/articles', payload)
export const uploadDoiFile = (type, file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.post(`/research-output/articles/import/${type}`, formData)
}
export const getTemplateDownloadLink = type =>
  request.get(`/research-output/articles/templates/${type}`, {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json'
    }
  })
